import gameConfig from './config.js';

export default class Cloud extends Phaser.GameObjects.Image {
    constructor(config) {
        super(config.scene, config.x, config.y, config.key, config.prevObjWidth, config.mapLength, config.speed);
        this.configX = config.x;
        this.speed = config.speed;
        this.prevObjWidth = config.prevObjWidth;
        this.mapLength = config.mapLength;
        this.scene = config.scene;
        this.scene.add.existing(this);
        this.setOrigin(0, 1);
        this.setScrollFactor(0); 
        this.setDepth(0);
    }
    update(isPaused = false, speedCoefficient = 1.5) {
        this.x -= isPaused ? 0 : this.speed * speedCoefficient;
        // Destroy dirt when it reaches the end of the screen
        if (this.x < -this.width) {
            // this.x += gameConfig.width + this.width;
            this.x = (this.mapLength - this.width);
        }

    }
}  